import { t } from '@lingui/core/macro'
import { showToast } from '@jotta/ui/ToastProvider'

export function displayJoinFolderShareSuccessAlert(folder: string) {
  showToast({
    message: t`You are now a member of ${folder} and changes to this folder is automatically synced between you and the other members.`,
    hasCloseButton: true,
    testid: 'JoinShareSuccess',
  })
}
